import { TPointCustomFieldAllSumsResponse } from '../../../points/points-custom-fields-sum/points-custom-fields-sum.const';

let customFieldSums: TPointCustomFieldAllSumsResponse | undefined;

export const GET_CF_SUM = (): TPointCustomFieldAllSumsResponse | undefined => customFieldSums;

export const SET_CF_SUM = (value: TPointCustomFieldAllSumsResponse): void => {
  customFieldSums = value;
};

export const CLEAR_CF_SUM = (): void => {
  customFieldSums = undefined;
};
